import { Component, OnInit, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { EnumerationService } from '../../../services/enumeration/enumeration.service';
import { SchemaField, Document, EnumerationValue } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';
import { UserProfileService } from '@app/modules/core/services/user-profile.service';

@Component({
    selector: 'app-business-units-column',
    templateUrl: './business-units-column.component.html',
    styleUrls: ['./business-units-column.component.scss'],
    standalone: false
})
export class BusinessUnitsColumnComponent implements OnInit, DynamicColumn {
  _field: SchemaField;
  _document: Document;


  @Input() set field(value: SchemaField) {
    this._field = value;
    if (!!this._document) {
      this.setFieldValue();
    }
  }
  @Input() set document(value: Document) {
    this._document = value;
    if (!!this._field) {
      this.setFieldValue();
    }
  }

  fieldValue: string;

  constructor(private userProfileService: UserProfileService) {}

  ngOnInit(): void {}

  private setFieldValue(): string {
    const value = this._document?.[this._field.systemName];

    const selectedItemUId = value;
    if (!selectedItemUId || !this.userProfileService.getUserHasBusinessUnits()) {
      this.fieldValue = '';
      return;
    }

    const values = [];

    const businessUnits = this.userProfileService.getUserBusinessUnits();

    value?.map(id => {
      const selectedItem = businessUnits?.find(p => p.uId === id) as EnumerationValue;
      if (selectedItem) {
        values.push(selectedItem.name);
      }
    });
    this.fieldValue = values.join(', ');
  }
}
